(function ($) {

	class CheckoutContact {

		$contact_form = null
		$billing_fields = null
		$add_billing_info = null

		constructor() {
			$(document).gp_ready(this.init_form)
		}

		init_form = () => {

			// Init elements
			this.$contact_form = $('form[data-form-id="checkout-contact"]')
			this.$billing_fields = this.$contact_form.find('.billing-address')
			this.$add_billing_info = this.$contact_form.find('input[name="add_billing_info"]')

			// Init toggle events
			this.init_toggle_content('add_billing_info', '.billing-address')
			this.init_toggle_content('sign_up', '.checkout-sign-up__password')

		}

		init_toggle_content(checkbox_name, content_selector) {

			let $checkbox = this.$contact_form.find('input[name="' + checkbox_name + '"]')
			let $content = this.$contact_form.find(content_selector)

			// Show/hide on init
			if ($checkbox.is(':checked')) {
				$content.show()
			} else {
				$content.hide()
			}

			// Bind toggle
			$checkbox.off('change.toggle-' + checkbox_name)
			$checkbox.on('change.toggle-' + checkbox_name, () => {
				if ($checkbox.is(':checked')) {
					$content.slideDown(250)
				} else {
					$content.slideUp(250)
				}
			})
		}

	}

	new CheckoutContact();

})(jQuery)